"use strict";

window.openWindow = (url, type, width, height, winName) => {
    let paramStr="";

    if (type==="console") {
        paramStr="resizable,height="+height+",width="+width;
    } else if (type==="econsole") {
        paramStr="resizable,scrollbars,height="+height+",width="+width;
    } else if (type==="fixed") {
        paramStr="status,height="+height+",width="+width;
    } else if (type==="elastic") {
        paramStr="toolbar,menubar,scrollbars,"+"resizable,location,height="+height+",width="+width;
    }

    if(!winName) {
        winName = ('myWin_'+url.substr(0,url.indexOf("."))).replace(/[\/\\]/g,'_');
    }

    const winObj = window.open(url, winName, paramStr);
    winObj.focus();
}

window.openContact = () => {
    window.openWindow( 'http://www.bluemarmot.com/contact.php?ws=hcgd', 'console', '350', '475', 'contactWin' );
}

window.openPrivacy = () => {
    let privacyWin = window.open('http://www.bluemarmot.com/privacy.phtml?ws=hcgd','privacy','width=450,height=500,scrollbars=1,resizable=1');
    privacyWin.focus();
}

window.openAbout = (from) => {
    let contactWin = window.open('http://www.bluemarmot.com/about.phtml?ws='+from,'about','width=450,height=500,scrollbars=1,resizable=1');
    contactWin.focus();
}

window.GoT = (obj,a) => {
    window.location.href = obj.href+'?'+a;
}

window.GoT2 = a => {
    window.location.href = a;
}

window.bzAjaxRequest = (url,resultDiv,formname,donefunction) => {
  let ajaxObj = bzGetAjaxObj();

	ajaxObj.onreadystatechange = function() {
		if(ajaxObj.readyState===4 && ajaxObj.status===200) {
			if(resultDiv) {
				if(typeof resultDiv==='string') {
					resultDiv=document.getElementById(resultDiv);
					if(!resultDiv) { return; }
				}
				resultDiv.innerHTML = ajaxObj.responseText;
			}
			if (donefunction) {
				if (typeof(donefunction) === "function") {
					donefunction.call(ajaxObj);
				}
				else {
					eval(donefunction);
				}
			}
		}
	};

	let p = null, m='GET';

	if(formname) {
	  let s = bzFormVarsToQueryString(formname);
		if(s) { p=s; }
		m='POST';
	}

	ajaxObj.open(m, url, true);
	ajaxObj.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	ajaxObj.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	ajaxObj.send(p);
}

window.bzGetAjaxObj = () => {
  let obj;
	try{
		// Opera 8.0+, Firefox, Safari
		obj = new XMLHttpRequest();
	} catch (e) {
		// Internet Explorer Browsers
		try{
			obj = new ActiveXObject("Msxml2.XMLHTTP");
		} catch (e) {
			try{
				obj = new ActiveXObject("Microsoft.XMLHTTP");
			} catch (e){
				obj = false;
			}
		}
	}
	return obj;
}

window.bzFormVarsToQueryString = formName => {
	let i, s; // index, string
  let f, e; // form, element
  let d = false; // done
  let dd;
	
	f = typeof formName  === 'object' ? formName : document.getElementById(formName);

	if(!f) {
		return '';
	}

	if(!f.elements) {
		return '';
	}

	s = '';
	
	for (i = 0; i < f.elements.length; i++) {
		e = f.elements[i];

		if (d) s += "&";
		if (e.type === 'checkbox' || e.type === 'radio') {
			if (e.checked) s += e.name + "=" + e.value;
		}
		else if (e.type === 'select-multiple') {
			dd = false;
			for (let j = 0; j < e.options.length; j++) {
				if (dd) s += "&";
				if (e.options[j].selected) s += e.name + "=" + e.options[j].value;
				dd = true;
			}
		}
		else {
			s += e.name + "=" + escape( e.value );
		}
		d = true;
	}
	return s;
}

window.bzNoCache = x => {
	return (x?'&':'')+'nocache='+Math.round(Math.random()*1000000);
}

window.bzIndexOf = (a,val) => {
	for(let i=0;i<a.length;i++) {
		if(a[i]===val) { return i; }
	}
	return -1;
}

( (window, document) => {

    // a global window.load/onload callback event binder
    // useful when you need to attach multiple
    // functions or anonymous functions to the window.load/onload event
    window.EbizOnloadEvent = (callback) => {
      if (document.readyState !== 'loading') {
        callback();
      }
      // W3C standard
      else {
        window.addEventListener('load', callback, false);
      }
    }

})(window, document);
